import type { FaireProductEntity } from "../../entity_types/product";

export const p_3vh0y7xo: FaireProductEntity = {
  token: "p_3vh0y7xo",
  type: "product",
  name: "No. 02 Amber + Oakmoss Candle - Shades Collection",
  brandToken: "b_oaph28jf",
  brandName: "dilo",
  imageUrl:
    "https://cdn.faire.com/fastly/8ae118f99559442386dea771bd88851cd68ba48719bf5dc78135f6ce69e53af0.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/de77a79c36d78670a544eca05a743553aa9f9e748b343c249916d589dd5530a4.png",
    "https://cdn.faire.com/fastly/dd126dad79464900e27cd23b772840fb387c5cec8408316fd35e69ad48907ca4.jpeg",
    "https://cdn.faire.com/fastly/5e9fef147f699bfa19cd270f56f6a7216cceb5dc8b36fcc45b0acd4739a84d45.png",
  ],
  priceDollars: 18,
  description:
    "dilo. candles are hand poured and made using 100% USA grown Soy Wax. \n\nNo. 02 Amber + Oakmoss has base notes of amber and musk balanced with citrus and wood notes.\n\nThe Shades Collection offers a new look to the already beloved dilo scents. Matte glass vessel housed in a heavy stock, foil printed box - providing for a look bold enough to match the candle within.\n\nTop Notes: Amber - Blood Orange\nHeart: Oakmoss - Patchouli\nBase: Sandalwood - Amber - Musk\n\n10 ounces - Burns 60 Hours\nAll candles are Phthalate-free, using cotton wicks with no lead cores for safer, cleaner burning.\n",
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:09.657Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
